import { AddTrainingEventSubscriptionRequest } from './add.training.event.subscription.request';

export class AddTrainingEventSubscriptionOnlyRequest extends AddTrainingEventSubscriptionRequest {
    TrainingEvent_ID: number;
}
